var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingState.schedule)?_c('loader'):_c('div',{staticClass:"schedule"},[(!_vm.error)?_vm._l((_vm.tables),function(table,key){return _c('tournament-schedule-table',{key:key,attrs:{"id":_vm.id,"table":table.rounds,"title":table.name}})}):_c('p',{staticClass:"error"},[_vm._v(" "+_vm._s(_vm.$t('tournaments.placeholders_schedule'))+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }